export default __webpack_public_path__ + "src/images/packages/safari-moon-lodge/6b54a6c0a5fd48f8990d0dd08771af0f-5.jpg";